import ErrorBoundary from "../../error-boundary";
import React from 'react';
import ReactDOM from 'react-dom';

import GDLoadingOverlap from '../../gd-components/loading/gd-loading-overlap/gd-loading-overlap';

const debug = {
    dev: false,
    error: true,
    head: "[App-Layout]"
};

export enum BackgroundColor {
    GRAY        = 'gray',
    WHITE       = 'white'
}

type Props = {
    app?                : any       // do we need it ?
    fullHeight?         : boolean
    children            : any
    className?          : string
    style?              : style

    tabIndex?           : number,   // for shortcuts
    onKeyPress?         : callback    // for shortcuts

    backgroundColor?    : BackgroundColor
}

export default class AppLayout extends React.Component<Props> {

    public blurAddedCount   : number = 0
    public loadingComponent   : any

    constructor(props:Props) {
        super(props);
    }


    // static propTypes = {
    //     fullHeight: PropTypes.bool,
    //
    //     tabIndex: PropTypes.string,   // for shortcuts
    //     onKeyPress: PropTypes.func    // for shortcuts
    // };

    static defaultProps = {
        fullHeight: false
    };

    componentDidMount() {
        if (debug.dev) console.log(debug.head,'.componentDidMount');

        gd.bus.subscribe('app-add-blur',this,this.addBlur);
        gd.bus.subscribe('app-remove-blur',this,this.removeBlur);
        gd.bus.subscribe('app-show-loading-overlap',this,this.showLoading);
        gd.bus.subscribe('app-hide-loading-overlap',this,this.hideLoading);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    addBlur = () => {
        const element = ReactDOM.findDOMNode(this.refs.container);
        this.blurAddedCount++;

        if (element) {
            // @ts-ignore
            element.classList.add("blur");
            // @ts-ignore
            element.parentElement.classList.add("blur-cover");
        }

        const topPanelEl = document.getElementById("ui-top-panel");
        if (topPanelEl) {
            topPanelEl.classList.add("blur-cover");
            // @ts-ignore
            topPanelEl.firstChild.classList.add("blur");
        }
    };

    removeBlur = () => {
        const element = ReactDOM.findDOMNode(this.refs.container);
        this.blurAddedCount--;

        if (this.blurAddedCount <= 0){
            if (element) {
                // @ts-ignore
                element.classList.remove("blur");
                // @ts-ignore
                element.parentElement.classList.remove("blur-cover");
            }

            const topPanelEl = document.getElementById("ui-top-panel");
            if (topPanelEl) {
                topPanelEl.classList.remove("blur-cover");
                // @ts-ignore
                topPanelEl.firstChild.classList.remove("blur");
            }
        }
    };

    showLoading = () => {
        const show = ()=>{if(this.loadingComponent) this.loadingComponent.showLoading(true)};
        if (this.loadingComponent) show();
        else setTimeout(show,0);
    };

    hideLoading = () => {

        // this is a patch and older version support
        if (gd.layout.loading) gd.layout.loading.hide(); // print to pdf app has no gd.layout.loading

        const show = ()=>{if(this.loadingComponent) this.loadingComponent.showLoading(false)};
        if (this.loadingComponent) show();
        else setTimeout(show,0);


    };

    render() {
        if (debug.dev) console.count(debug.head+".render()");

        const classes = Classes('gd-app', this.props.className,{
            'h100'              : _.get(this.props, 'fullHeight', false),
            'ui5-bg-gow'        : this.props.backgroundColor === BackgroundColor.GRAY
        });

        return (
            <div ref="container" className={classes} onKeyPress={this.props.onKeyPress} tabIndex={this.props.tabIndex} style={this.props.style}>
                <ErrorBoundary>
                {this.props.children}

                <GDLoadingOverlap ref={c=>{this.loadingComponent=c}}/>
                </ErrorBoundary>
            </div>
        );
    }
}

// module.exports = AppLayout;
